import React from "react"

interface Props {
  children: React.ReactNode
}

export const ModalBody = ({ children }: Props) => (
  <section className="modal-body">{children}</section>
)
